//@flow
import { AddFavItemsQuery, AddFavItemsMsg, FavItemDetail, RepoItem } from '../../autogenerated/ZoomBridge';
import { FAV_ITEM_DETAIL_MAP } from '../../store/Constants';
import Store from '../../store/Store';
import FileInfoUtil from '../../util/FileInfoUtil';
const debug = require('../../debug/debug')('wc:queries:FavoriteUtil');


export function OnyAddFavAssets(assets: Array<RepoItem>) {
  const addFavQuery = new AddFavItemsQuery();
  const addFavQueryMsg = new AddFavItemsMsg();
  addFavQueryMsg.setFavItemObjectArray(assets);
  addFavQueryMsg.setActionType('Add');
  addFavQuery.message = addFavQueryMsg;
  return new Promise((onResolve, onError)=> {
    addFavQuery.run().then(resp => {
      Store.put(FAV_ITEM_DETAIL_MAP, resp.getFuid2FavItemObject());
      onResolve(resp);
    }).catch(err=> onError(err));
  });
}

export function favAddRemoveOperation(asset) {
  return new Promise((resolve, reject) => {
    if (!asset) {
      reject('No Asset Found');
    } else {
      const isFav = FileInfoUtil.isFavAsset(asset.getFuid());
      const addFavQuery = new AddFavItemsQuery();
      const addFavQueryMsg = new AddFavItemsMsg();
      addFavQueryMsg.setActionType(isFav ? 'Remove' : 'Add');
      const favItemDetail = setFavItemDetails(asset);
      addFavQueryMsg.setFavItemObjectArray([favItemDetail]);
      addFavQuery.message = addFavQueryMsg;
      addFavQuery.run().then(
        (resp) => {
          debug('[favAddRemoveOperation()] resp: ', resp);
          Store.put(FAV_ITEM_DETAIL_MAP, resp.getFuid2FavItemObject());
          resolve(resp);
        },
        (error) => {
          debug('[favAddRemoveOperation()] error: ', error);
          reject(error);
        }
      );
    }
  });
}

export function removeFavItem(asset) {
  return new Promise((resolve, reject) => {
    const addFavQuery = new AddFavItemsQuery();
    const favItemDetail = setFavItemDetails(asset);
    addFavQuery.message = favQueryMsg(favItemDetail);
    addFavQuery
      .run()
      .then((resp) => {
        debug('[removeFavItem()] resp: ', resp);
        Store.put(FAV_ITEM_DETAIL_MAP, resp.getFuid2FavItemObject());
        resolve(resp);
      })
      .catch((error) => {
        debug('[removeFavItem()] error: ', error);
        reject(error);
      });
  });
}

export function setFavItemDetails(asset) {
  const favItemDetail = new FavItemDetail();
  favItemDetail.setBid(asset.getBid());
  favItemDetail.setFuid(asset.getFuid());
  favItemDetail.setMtime(asset.getMtime());
  favItemDetail.setIsFile(asset.getBasicFileAttributes ? asset.getBasicFileAttributes().isFile() : asset.isIsFile());
  favItemDetail.setName(asset.getName());
  return favItemDetail;
}

export function favQueryMsg(favItemDetail) {
  const addFavQueryMsg = new AddFavItemsMsg();
  addFavQueryMsg.setActionType('Remove');
  addFavQueryMsg.setFavItemObjectArray([favItemDetail]);
  return addFavQueryMsg;
}

